import IntervalReservationApp from '@vue/app/IntervalReservationApp.vue';
import { createApp } from 'vue';
await S.import('@main');
await u.domready();
const axios = await u.$http.createHttp();
axios.defaults.baseURL = u.data('apiEndpoint');
// 請求逾時（2026-10-13 驗收報告第 4 節）：原本是 axios 預設的 0＝永遠等，
// 後端不回應時「送出中…」永遠 disabled，客人也不知道訂位有沒有成立。
// 讀取 20 秒；寫入 120 秒——發驗證碼走簡訊備援鏈最壞要 50 秒以上，
// 太短的話後端其實成功了、前端卻判定失敗，客人一重送就是重複訂位（與後台同一組數字）。
axios.interceptors.request.use((config) => {
    if (!config.timeout) {
        config.timeout = (config.method ?? 'get').toLowerCase() === 'get' ? 20_000 : 120_000;
    }
    return config;
});
const app = createApp(IntervalReservationApp, u.data('app.props'));
app.mount('#interval-reservation-app');
